import { PAGE } from "constants/index";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import classes from "./TrustPilotBadge.module.scss";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import Star from "@Icons/Star";

const TrustPilotBadge = (props: any) => {
  const reviewsObj = useSelector(
    ({ propertyPageData }: AppState) => ({
      reviews_count: propertyPageData?.inventoryReviewData?.length || 0,
      reviews_rating: propertyPageData.data?.reviews_rating,
    }),
    shallowEqual,
  );
  const { reviews_count, reviews_rating } = JSON.stringify(props) != "{}" ? props : reviewsObj;
  const { className } = props;
  const onClickReviews = (e: any) => {
    e.stopPropagation();
    gtagEventEmitter({ action: "clicked_review_tag", category: PAGE.INVENTORY, label: "Review" });
    const element = document.getElementById("reviews");
    if (!element) return;
    const headerOffset = 54 + 48; // padding plus navbar height
    const elementPosition = element?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
    });
  };

  return (
    <>
      {reviews_count && reviews_rating >= "4.0" ? (
        <div
          data-testid="property-page-gallery-trustpilot-badge"
          className={formatClassNames(className, classes.TrustpilotContainer)}
          onClick={onClickReviews}
          role="none"
        >
          <Star size="clamp(10px, 1.2vw, 12px)" />
          <span data-testid="property-rating" className={classes.ratingSpan}>
            {reviews_rating}
            <span
              data-testid="property-page-trustpilot-property-review-count"
              className={classes.ratingInnerSpan}
            >
              ({reviews_count})
            </span>
          </span>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default wrapperHOC(TrustPilotBadge, {
  componentName: "TrustPilotBadge-Global",
  showForChina: true,
});
